import { NgClass } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { ClientSideDataTable, Column } from '@ng-cloud/badger-core/common/data-table';
import { StartCasePipe } from '@ng-cloud/badger-core/common/pipes/start-case.pipe';
import { FocusResult } from '@ng-cloud/badger-core/models/focus-result';
import { RobotService } from '@ng-cloud/badger-core/services/robot.service';
import { ClassDirective } from '@ngbracket/ngx-layout/extended';
import { FlexDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';
import { saveAs } from 'file-saver';

import * as _ from 'lodash';
import { BooleanComponent } from '../boolean/boolean.component';

@Component({
  selector: 'bt-robot-focus-play-details',
  templateUrl: './robot-focus-play-details.component.html',
  styleUrls: ['./robot-focus-play-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BooleanComponent,
    ClassDirective,
    FlexDirective,
    LayoutDirective,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatRow,
    MatRowDef,
    MatTable,
    MatTooltip,
    NgClass,
    StartCasePipe
  ]
})
export class RobotFocusPlayDetailsComponent implements OnInit {
  readonly CLEAR_MODE = 'clear';
  readonly IMAGE_MODE = 'image';
  readonly LOG_FILE_MODE = 'logFile';

  @ViewChild('logFileFrame', { static: false }) logFileFrame;

  playExecutionId: number;
  focusResult: FocusResult;
  imageUrl: string;

  displayMode = this.CLEAR_MODE;

  dataTable: ClientSideDataTable<FocusResult> =
    new ClientSideDataTable<FocusResult>([
      new Column('cam'),
      new Column('status'),
      new Column('image'),
      new Column('log'),
      new Column('download')
    ]);

  constructor(
    private route: ActivatedRoute,
    protected robotService: RobotService,
    protected http: HttpClient
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.playExecutionId = +params.get('playExecutionId');
      this.robotService
        .getFocusResults(this.playExecutionId)
        .subscribe((focusResults) => {
          this.dataTable.data = _.sortBy(
            focusResults,
            (focusResult) => focusResult.cam
          ).reverse();
        });
    });
  }

  setFocusResult(focusResult: FocusResult) {
    this.focusResult = focusResult;
  }

  clearDisplay() {
    this.displayMode = this.CLEAR_MODE;
  }

  setDisplayMode(displayMode) {
    this.displayMode = displayMode;
  }

  displayImage(focusResult: FocusResult) {
    this.setDisplayMode(this.IMAGE_MODE);
    this.setFocusResult(focusResult);
    this.imageUrl = focusResult.focusImageUrl;
  }

  displayLogFile(focusResult: FocusResult) {
    this.setDisplayMode(this.LOG_FILE_MODE);
    this.setFocusResult(focusResult);
    this.logFileFrame.nativeElement.src = focusResult.focusLogUrl;
  }

  download(focusResult: FocusResult) {
    fetch(focusResult.focusLogUrl)
      .then((r) => r.text())
      .then((t) =>
        saveAs(
          new Blob([t], { type: 'text/plain;charset=utf-8' }),
          'band_' +
          focusResult.focusBand +
          '_' +
          focusResult.cam +
          '_focus_log.txt'
        )
      );
  }
}
